<template>
    <div>
        <Banner :banners="banners" show-overlay> </Banner>
        <Breadcrumb></Breadcrumb>
        <div class="info-wrapper default">
            <h2 class="title text-center">列表導覽</h2>
            <div class="search-wrapper mb-3">
                <div class="d-flex">
                    <div class="input-group mr-1">
                        <input
                            type="text"
                            class="form-control"
                            placeholder="請輸入關鍵字"
                            v-model="paras.keyword"
                            @keyup.enter="query"
                        />
                        <div class="input-group-append">
                            <button class="btn btn-search" @click="query">
                                <img
                                    src="@/assets/common_ic_enter_search.png"
                                    alt="search"
                                />
                            </button>
                        </div>
                    </div>
                    <button class="btn btn-filter" @click="toggleSearchFilter">
                        <img
                            src="@/assets/common_ic_enter_filter.png"
                            alt="filter"
                        />
                    </button>
                </div>
                <div
                    class="search-filter"
                    ref="filter"
                    v-show="searchFilterShow"
                >
                    <ul class="row form-row m-0">
                        <li class="col-4">
                            <div
                                class="item"
                                @click="toggleType('isCommentary')"
                                :class="{ active: paras.isCommentary }"
                            >
                                柳川步道解說牌
                            </div>
                        </li>
                        <li class="col-4">
                            <div
                                class="item"
                                @click="toggleType('isAttraction')"
                                :class="{ active: paras.isAttraction }"
                            >
                                景點
                            </div>
                        </li>
                        <li class="col-4">
                            <div
                                class="item"
                                @click="toggleType('isFood')"
                                :class="{ active: paras.isFood }"
                            >
                                美食
                            </div>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="alert-text" v-show="positionErrorText">
                <span
                    v-text="'(' + positionErrorText + ')'"
                    class="text-danger"
                ></span>
                <!-- <button class="btn btn-sm" @click="getCurrentPosition">
                    <i class="fa fa-map-marker" aria-hidden="true"></i>
                </button> -->
            </div>
            <div class="result-total-text">
                共有{{ pagination.total }}項結果
            </div>
            <Loader :show="loading"></Loader>
            <ul class="px-1 py-2" v-show="!loading">
                <li
                    v-for="attraction in attractionListPagination"
                    :key="attraction.id"
                >
                    <a href="" @click.prevent="goDetail(attraction.id)">
                        <div class="list-card green">
                            <div class="img-wrapper">
                                <vue-load-image>
                                    <img
                                        slot="image"
                                        :src="
                                            `${apiPhotoUrl}/ori/${attraction.photoId}`
                                        "
                                        :alt="attraction.name"
                                    />
                                    <img
                                        slot="preloader"
                                        src="@/assets/image-loader.gif"
                                        class="w-100"
                                    />
                                    <img
                                        slot="error"
                                        class="border d-block bg-white"
                                        src=""
                                        alt="not found"
                                    />
                                </vue-load-image>
                            </div>
                            <div class="card-body">
                                <div class="title" v-text="attraction.name">
                                    柳川河濱公園
                                </div>
                                <div
                                    class="distance"
                                    v-show="attraction.distance"
                                >
                                    <img
                                        src="@/assets/self_ic_map.png"
                                        alt="距離"
                                    />{{ attraction.distance }}m
                                </div>
                            </div>
                        </div>
                    </a>
                </li>
            </ul>
            <Pagination
                :page-total="
                    Math.ceil(
                        this.nearbyAttractionList.length /
                            this.pagination.pageSize,
                    )
                "
                :page-index="pagination.currentPage"
                @change-index="pagination.currentPage = $event"
            ></Pagination>
        </div>
    </div>
</template>

<script>
/* eslint-disable global-require */
import { mapGetters, mapState, mapActions } from 'vuex';
import $ from 'jquery';
import Banner from '@/components/shared/Banner';
import Breadcrumb from '@/components/Breadcrumb';
import Loader from '@/components/Loader';
import coreMixin from '@/js/mixin/coreMixin';
import { getDistanceByPoint } from '@/js/map/tool';
import { apiAttractions, apiRiverDetail } from '@/plugin/api';

export default {
    data() {
        return {
            banners: [
                {
                    linkUrl: require('@/assets/instruction_img.jpg'),
                },
            ],
            searchFilterShow: false,
            paras: {
                keyword: '',
                isCommentary: null,
                isAttraction: null,
                isFood: null,
                currentPage: 1,
                pageSize: 10,
            },
            attractionList: [],
            loading: false,
        };
    },
    mounted() {
        this.query();
    },
    computed: {
        ...mapGetters('userData', ['showDistance', 'positionErrorText']),
        ...mapState('userData', ['currentPosition']),
        nearbyAttractionList() {
            let nearbyList = [...this.attractionList];
            // 使用者位置在有效範圍內
            if (this.showDistance) {
                // 計算距離使用者到景點距離
                nearbyList = this.attractionList.map((spot) => {
                    const distance = parseInt(
                        getDistanceByPoint(this.currentPosition, [
                            +spot.lon,
                            +spot.lat,
                        ]),
                        10,
                    );
                    return { ...spot, distance };
                });
                // 依距離作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'distance';
                    return a[sortColumn] - b[sortColumn];
                });
            } else {
                // 依id作排序;
                nearbyList.sort((a, b) => {
                    const sortColumn = 'id';
                    return `${a[sortColumn]}`.localeCompare(b[sortColumn]);
                });
            }

            return nearbyList;
        },
        attractionListPagination() {
            const nList = [];
            for (
                let i = 0;
                i < this.nearbyAttractionList.length / this.pagination.pageSize;
                // eslint-disable-next-line no-plusplus
                i++
            ) {
                nList.push(
                    this.nearbyAttractionList.slice(
                        i * this.pagination.pageSize,
                        (i + 1) * this.pagination.pageSize,
                    ),
                );
            }
            return nList[this.pagination.currentPage - 1];
        },
        allType: {
            get() {
                return (
                    (!this.paras.isCommentary
                        && !this.paras.isAttraction
                        && !this.paras.isFood)
                    || (this.paras.isCommentary
                        && this.paras.isAttraction
                        && this.paras.isFood)
                );
            },
            set(type) {
                this.paras[type] = !this.paras[type];
                this.query();
            },
        },
        pageTotal() {
            return Math.ceil(
                this.nearbyAttractionList.length / this.paras.pageSize,
            );
        },
    },
    methods: {
        ...mapActions('userData', [
            'setCurrentPosition',
            'setPositionErrorCode',
        ]),
        goDetail(id) {
            this.$router.push({ name: 'AttractionsDetail', params: { id } });
        },
        toggleType(type) {
            this.allType = type;
        },
        async getOpenApiAttractions() {
            this.loading = true;
            await apiAttractions({
                ...this.paras,
                pageSize: 100000,
            }).then((res) => {
                if (res.data.success) {
                    this.attractionList = res.data.data.map((item) => ({
                        ...item,
                        lat: +item.latitude,
                        lon: +item.longitude,
                        name: item.name,
                        id: item.attractionId,
                    }));
                    this.setPagination({
                        pageSize: this.paras.pageSize,
                        total: res.data.total,
                    });
                }
            }, this.errorHandler);
            this.loading = false;
        },
        toggleSearchFilter() {
            this.searchFilterShow = !this.searchFilterShow;
            setTimeout(() => {
                if (this.searchFilterShow) {
                    document.addEventListener(
                        'click',
                        this.toggleSearchFilterHandle,
                    );
                } else {
                    document.removeEventListener(
                        'click',
                        this.toggleSearchFilterHandle,
                    );
                }
            }, 0);
            this.$nextTick(() => {});
        },
        toggleSearchFilterHandle(e) {
            if (
                e.target !== this.$refs.filter
                && !$(this.$refs.filter).has(e.target).length
            ) {
                this.searchFilterShow = false;
                document.removeEventListener(
                    'click',
                    this.toggleSearchFilterHandle,
                );
            }
        },
        query() {
            this.getOpenApiAttractions();
        },
        async getRiverDetailName() {
            const { id } = this.$route.params;
            return apiRiverDetail(id).then((res) => {
                if (res.data.success) {
                    return res.data.data.name;
                }
                return id;
            }, this.errorHandler);
        },
        getCurrentPosition() {
            navigator.geolocation.getCurrentPosition(
                // success
                (pos) => {
                    this.setCurrentPosition([
                        pos.coords.longitude,
                        pos.coords.latitude,
                    ]);
                },
                // error
                (error) => {
                    console.log(error.message);
                    this.setCurrentPosition([0, 0]);
                    this.setPositionErrorCode(error.code);
                },
            );
        },
    },
    components: {
        Banner,
        Breadcrumb,
        Loader,
    },
    mixins: [coreMixin],
    beforeRouteEnter(to, from, next) {
        if (from.name === 'RiverDetail') {
            to.meta.breadcrumb = [
                ...from.meta.breadcrumb,
                {
                    name: '更多周邊景點',
                    link: `${
                        from.meta.breadcrumb[from.meta.breadcrumb.length - 1]
                            .link
                    }/around`,
                },
            ];
        }
        next();
    },
};
</script>

<style></style>
